import { render, staticRenderFns } from "./OtherUserMessageReplyDetail.vue?vue&type=template&id=3d1e1bd8&lang=pug"
import script from "./OtherUserMessageReplyDetail.vue?vue&type=script&lang=ts"
export * from "./OtherUserMessageReplyDetail.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserMessageReplyDetail.vue?vue&type=style&index=0&id=3d1e1bd8&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports